import styled from 'styled-components';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

import Card from './UseCaseCard';

const Cards = styled.div`
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
`;

const CardComp = props => (props.cards ? props.cards.map(card => <Card imgurl={card.imgurl} data={card.data} />) : '');

export default () => {
  const [cardData, setCardData] = useState('');
  axios
    .get('https://api.sheety.co/be602377-b127-449a-baa2-5b8f0bb272f2')
    .then(resp => setCardData(resp.data.slice(0, 5)));
  return (
    <Cards>
      <CardComp cards={cardData} />
    </Cards>
  );
};
